/**
 * ZeoScopeHeader - oberer Balken der ZEO-Vollbildseite.
 * Zeigt den fest gebundenen Scope (Buero oder Klientenname) an.
 * Reiner Anzeige-Zweck -- der Scope selbst wird ausschliesslich in
 * ZeoPage.jsx aus den URL-Query-Params gelesen und NIE hier veraendert.
 */
import ZeoIcon from '@/components/ZeoIcon';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';

export default function ZeoScopeHeader({ scope, klientName, sidebarOpen, onToggleSidebar }) {
  const scopeLabel = scope === 'client' ? (klientName || 'Klient wird geladen…') : 'Büro';

  return (
    <div className="h-16 shrink-0 flex items-center gap-3 px-5 border-b border-violet-100 bg-white/80 backdrop-blur">
      <button
        type="button"
        onClick={onToggleSidebar}
        className="p-2 rounded-lg text-slate-400 hover:text-violet-600 hover:bg-violet-50 transition-colors"
        title={sidebarOpen ? 'Sidebar einklappen' : 'Sidebar ausklappen'}
        data-testid="zeo-sidebar-toggle"
      >
        {sidebarOpen ? <PanelLeftClose size={18} /> : <PanelLeftOpen size={18} />}
      </button>

      <div className="w-9 h-9 rounded-full bg-violet-50 flex items-center justify-center shrink-0">
        <ZeoIcon size={26} />
      </div>

      <div className="flex flex-col leading-tight">
        <span className="font-semibold text-slate-800 text-[15px]">ZEO</span>
        <span className="text-xs text-slate-500">{scopeLabel}</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <span
          className="text-[11px] px-2 py-1 rounded-full font-medium"
          style={{ background: 'rgba(139,92,246,0.10)', color: '#6d28d9' }}
          data-testid="zeo-scope-badge"
        >
          {scope === 'client' ? klientName || 'Klient' : 'Büro'}
        </span>
        <span className="text-[11px] text-slate-400 hidden sm:inline">Qwen 3.8 · Mittwald</span>
      </div>
    </div>
  );
}
